import React, { memo } from 'react';
import compose from 'recompose/compose';
import PropTypes from 'prop-types';
import { Panel } from 'react-bootstrap';

import SelectedFile from '../entity/SelectedFile';
import PanelHeading from './PanelHeading';

const SelectedFileErrorPanel = ({
    file,
    deleteFile,
    columnGridCount,
}) => (
    <Panel bsStyle="danger" className="panel-bordered">
        <PanelHeading
            text={`${file.getUploadedFile().getName()} (${file.getSizeAsString()})`}
            iconClass="icon-cancel"
            deleteFile={() => deleteFile(file.getId())}
            columnGridCount={columnGridCount}
        />
        <Panel.Body>
            {file.getErrorData()}
        </Panel.Body>
    </Panel>
);

SelectedFileErrorPanel.propTypes = {
    file: PropTypes.instanceOf(SelectedFile).isRequired,
    deleteFile: PropTypes.func.isRequired,
    columnGridCount: PropTypes.number.isRequired,
};

export default compose(
    memo,
)(SelectedFileErrorPanel);
